





































































import { Component, Watch, Vue, Emit, Prop } from 'vue-property-decorator';
import { institutionServer, professionServer, schedulePlan, userServe } from '@/api/installServer';
import { deepClone } from '@/util/deepClone';
import { arrayToTree } from '@/util/arrayToTree';

@Component
export default class AnswerDeploymentStaff extends Vue {
  @Prop({ default: '' }) private _title!: string;
  @Prop(String) private spaceId!: string;
  private visible = false;
  private type = '';
  private ruleIndex: any = '';
  private staffData: any = {};
  private departList: any = [];
  private postList: any = [];
  private staffList: any = {
    records: [],
    total: 0,
    current: 1,
    size: 5,
  };
  private selectList: any = [];
  // private total: any = 0;
  // private pageNo: any = 1;
  // private pageSize: any = 5;
  private form: any = {
    staffList: [],
    departId: '',
    postId: '',
    staffName: '',
  };
  private _showOnce = false;
  private currentData: any = [];
  private spaceIdChange: any = '';
  private spaceList: any = {};
  private companyAllData: any = [];
  private companyData: any = [];
  private companyDataArr: any = [];

  created() {}

  /**
   * 窗口标题
   * @Params
   * @return
   **/
  get title() {
    if (this._title != '') return this._title;
    const typeMap: any = {
      select: '选择考试人员',
    };
    return typeMap[this.type];
  }

  /**
   * 处理首次打开窗口
   */
  async handleShowOnce() {
    if (this._showOnce) return;
    this._showOnce = true;
  }

  /**
   * 打开选择人员窗口
   * @Params
   * @return
   **/
  async showDialog(index: any, staffList: any) {
    console.log(this.spaceId);
    this.type = 'select';
    this.ruleIndex = index;
    this.form.staffList = staffList;
    try {
      this.visible = true;
      this.getStaffList();
      this.getDeptAllData();
      this.getPostList();
      this.currentTreeUnitData();
      await this.handleShowOnce();
      this.getCompanyDataList();
    } catch (e) {}
  }

  /**
   * 关闭窗口
   * @Params
   * @return
   **/
  hideDialog() {
    this.onResponse();
    this.staffData = {};
    this.resetForm();
    this.staffList = [];
    this.visible = false;
  }

  spaceIdChecked(val: any) {
    this.staffList.current = 1;
    let str: any = '';
    if (val.constructor === Array && val.length > 0) {
      if (val.length > 1) {
        str = val[val.length - 1];
      } else {
        str = val[0];
      }
    }
    this.spaceIdChange = str;
    this.getDeptAllData();
    this.getPostList();
    this.getStaffList();
  }

  /**
   * 【接口】获取单位列表
   */
  private getCompanyDataList() {
    institutionServer
      .getCompanyList({})
      .then((res: any) => {
        if (res.code === '200') {
          const data: any = deepClone(res.data);
          this.companyDataArr = res.data;
          this.companyAllData = arrayToTree(data);
          this.getCompanyById(this.companyAllData);
        } else {
          this.$message.warning('获取数据失败，请稍后重试！');
        }
      })
      .catch((error: any) => {
        this.$message.warning('获取数据失败，请稍后重试！');
      });
  }

  /**
   * 组织机构中的数据 键值对
   **/
  getCompanyById(data: any) {
    if (data.constructor === Array && data.length > 0) {
      data.forEach((item: any) => {
        if (item.id === this.spaceId) {
          this.companyData.push(item);
        } else {
          if (item.children && item.children.constructor === Array && item.children.length > 0) {
            this.getCompanyById(item.children);
          }
        }
      });
    }
  }

  /**
   * 选中部门后请求人员数据
   **/
  changeDepart(val: any) {
    this.staffList.current = 1;
    this.form.departId = val ? val[val.length - 1] : '';
    this.getStaffList();
  }

  /**
   * 选中岗位后请求人员数据
   **/
  changePost(val: any) {
    this.staffList.current = 1;
    this.form.postId = val;
    this.getStaffList();
  }

  /**
   *【按钮】提交按钮点击
   * @Params
   * @return
   **/
  handleSubmitBtnClick() {
    this.hideDialog();
  }

  /**
   * 【按钮】批量操作按钮指令
   */
  handleBatchCommand(command: string) {
    if (this.selectList.length === 0) {
      this.$message.warning('请选择您要操作的数据。');
      return;
    }
    if (command === 'add') {
      let flagAll = true;
      this.selectList.forEach((item: any) => {
        let flag = true;
        this.form.staffList.forEach((staff: any) => {
          if (item.id === staff.id) {
            flag = false;
            flagAll = false;
          }
        });
        if (flag) {
          this.addstaff({
            id: item.id,
            name: item.name,
          });
        }
      });
      if (!flagAll) {
        this.$message.warning('人员出现重复添加,已进行合并。');
      }
    }
  }

  /**
   * 【表格】表格添加按钮点击
   */
  handleTableAddBtnClick(data: any) {
    this.staffData = data;
    this.addstaff({
      id: this.staffData.id,
      name: this.staffData.name,
    });
  }

  /**
   * 【分页】分页变化
   */
  handlePaginationCurrentChange(pageNo: number) {
    this.staffList.current = pageNo;
    this.getStaffList();
  }

  /**
   * 【分页】分页大小变化
   */
  handlePaginationSizeChange(pageSize: number) {
    this.staffList.size = pageSize;
    this.getStaffList();
  }

  handleClose(index: any) {
    this.form.staffList.splice(index, 1);
  }

  /**
   * 【表格】表格选择变化
   */
  handleTableSelectionChange(val: any) {
    this.selectList = val;
  }

  /**
   *【表单】表单重置
   * @Params
   * @return
   **/
  resetForm() {
    const formComponent: any = this.$refs['form'];
    formComponent.resetFields();
    this.form.departId = '';
    this.form.postId = '';
    this.form.staffName = '';
    // this.staffList = [];
    this.form.staffList = [];
    this.spaceIdChange = '';
    this.getStaffList();
  }

  /**
   *【按钮】添加人员
   * @Params
   * @return
   **/
  addstaff(staff: any) {
    let flag = true;
    this.form.staffList.forEach((item: any) => {
      if (item.id === staff.id) {
        flag = false;
      }
    });
    if (flag) {
      this.form.staffList.push(staff);
    } else {
      this.$message.warning('人员出现重复添加,已进行合并。');
    }
  }

  /**
   * @desc 获取可选部门接口
   */
  getDeptAllData() {
    institutionServer
      .getAllData({
        spaceId: this.spaceIdChange ? this.spaceIdChange : this.spaceId,
      })
      .then((res: any) => {
        if (res.code === '200') {
          const arr: any = arrayToTree(res.data);
          this.departList = arr;
        }
      })
      .catch((error: any) => {
        this.$message.error('数据请求失败，请稍后重试！');
      });
  }

  /**
   *【接口】获取岗位列表
   * @Params
   * @return
   **/
  getPostList() {
    professionServer
      .getPageDataAll({
        spaceId: this.spaceIdChange ? this.spaceIdChange : this.spaceId,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.postList = res.data;
        }
      })
      .catch((error: any) => {
        this.$message.error('数据请求失败，请稍后重试！');
      });
  }

  /**
   *【接口】获取人员列表
   * @Params
   * @return
   **/
  getStaffList(pageNo?: number) {
    this.staffList.current = pageNo || this.staffList.current;
    schedulePlan
      .getStaffList({
        deptId: this.form.departId ? this.form.departId : null,
        postId: this.form.postId,
        name: this.form.staffName,
        search: this.form.staffName,
        current: this.staffList.current,
        size: this.staffList.size,
        spaceId: this.spaceIdChange ? this.spaceIdChange : this.spaceId,
        postIdList: this.form.postId ? this.form.postId.toString() : null,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.staffList = res.data;
        } else {
          this.$message.warning('获取人员失败。');
        }
      });
  }

  /**
   * 获取组织结构数据
   **/
  currentTreeUnitData() {
    userServe
      .getCurrentOrgTree({})
      .then((res: any) => {
        if (res.code === '200') {
          this.currentData = deepClone(res.data);
          this.getObj(this.currentData);
        }
      })
      .catch((error: any) => {
        this.$message.error('初始化树形图数据失败!');
      });
  }

  /**
   * 组织机构中的数据 键值对
   **/
  getObj(data: any) {
    if (data.constructor === Array && data.length > 0) {
      data.forEach((item: any) => {
        this.spaceList[item.id] = item.name;
        if (item.child && item.child.constructor === Array && item.child.length > 0) {
          this.getObj(item.child);
        }
      });
    }
  }

  /**
   * 【广播】广播提交成功事件
   * @Params
   * @return
   **/
  @Emit('on-response')
  onResponse() {
    return {
      index: this.ruleIndex,
      staff: this.form.staffList,
    };
  }
}
